import styled from 'styled-components'
import { Text } from '@sketch/components'

export const Wrapper = styled.aside`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;

  padding: 0px 48px;
  text-align: center;
`

export const Icon = styled.svg`
  width: 64px;
  height: 64px;

  /* This color should be "Light/colors.state.disabled" but given the icon composition */
  /* Opacity needs to be applied to the whole object */
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  opacity: 0.3;
`

export const Title = styled(Text.H1).attrs({
  textStyle: 'copy.primary.standard.E',
})`
  margin: 0;

  ${Icon} + & {
    margin: 9px 0 0; /* stylelint-disable-line scales/space */
  }
`

export const Description = styled.span`
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  font-size: 0.8125rem; /* 13px */
  line-height: 1.4;
`
